import { gql } from "@apollo/client";

export const QUERY_FORM3457L_VERSION = gql`
  query studentForm3457L(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3457L(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      parent1
      parent2
      parentConsent
      studentConsent
      includeDHS
      includeDRS
      includeDD
      includeDSCC
      includePEDS
      includeMilitary
      includeOther
      nameOther
      schoolPersonnelTitle
      schoolPersonnelPhone
      consentAgencyInvitation
      parentSignatureDate
      studentSignatureDate
      formAction
      formStatus
    }
  }
`;
